module.exports = __webpack_public_path__ + "static/media/cargas-activas.2c3c3638.png";